module.exports = __webpack_public_path__ + "static/media/minaret.9eb0ac0e.png";